import { render, staticRenderFns } from "./tuwen_com.vue?vue&type=template&id=43b6ffb1&scoped=true"
import script from "./tuwen_com.vue?vue&type=script&lang=js"
export * from "./tuwen_com.vue?vue&type=script&lang=js"
import style0 from "./tuwen_com.vue?vue&type=style&index=0&id=43b6ffb1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b6ffb1",
  null
  
)

export default component.exports